"use client";
import {useState} from "react";
import {FiSidebar} from "react-icons/fi";
export const RoutesHistory = function () {
  const [isRigthDrawerOpen, setIsRightDrawerOpen] = useState(false);

  return (
    <>
      <div className="absolute right-12 top-2 z-10 w-64 rounded bg-white bg-opacity-90 p-2 shadow-md">
        <div className="flex items-center justify-between border-b px-4 py-2">
          {/* Title */}
          <h2 className="text-sm font-semibold text-gray-700">
            Route Change History
          </h2>

          {/* Action Icons */}
          <div className="flex items-center space-x-3">
            <button
              title="Open Drawer"
              className="text-gray-600 hover:text-gray-800"
              onClick={() => setIsRightDrawerOpen(!isRigthDrawerOpen)}
            >
              <FiSidebar className="h-5 w-5" />
            </button>
          </div>
        </div>
        {isRigthDrawerOpen && (
          <div className="max-h-[400px] space-y-4 overflow-y-auto pr-2">
            <div className="space-y-4">
              {[
                {
                  id: 1,
                  number: "Tn 38 DC 3795",
                  users: 8,
                  usersColor: "bg-green-100 text-green-600",
                  route: "R1_M_T01",
                  distance: "15.13km",
                  distanceColor: "text-green-600",
                  time: "08:14 - 09:14",
                  travel: "36min",
                  travelColor: "text-red-600"
                },
                {
                  id: 2,
                  number: "Tn 38 DC 3795",
                  users: 24,
                  usersColor: "bg-yellow-100 text-yellow-600",
                  route: "R1_M_T01",
                  distance: "25.13km",
                  distanceColor: "text-red-600",
                  time: "08:14 - 09:14",
                  travel: "36min",
                  travelColor: "text-red-600"
                },
                {
                  id: 3,
                  number: "Tn 38 DC 3795",
                  users: 24,
                  usersColor: "bg-yellow-100 text-yellow-600",
                  route: "R1_M_T01",
                  distance: "25.13km",
                  distanceColor: "text-red-600",
                  time: "08:14 - 09:14",
                  travel: "36min",
                  travelColor: "text-red-600"
                }
              ].map(v => (
                <div
                  key={v.id}
                  className="space-y-1 rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
                >
                  <div className="flex items-center justify-between">
                    <span className="rounded border border-blue-400 px-2 py-0.5 text-sm font-medium text-blue-700">
                      {v.number}
                    </span>
                    <span
                      className={`rounded-full px-2 py-0.5 text-xs font-medium ${v.usersColor}`}
                    >
                      {v.users} users
                    </span>
                  </div>
                  <p className="text-xs text-gray-500">{v.route}</p>

                  <div className="mt-2 space-y-1 text-sm">
                    <p>
                      <span className="text-gray-500">Distance: </span>
                      <span className={v.distanceColor}>→ {v.distance}</span>
                    </p>
                    <p>
                      <span className="text-gray-500">Time: </span>
                      {v.time}
                    </p>
                    <p>
                      <span className="text-gray-500">Travel: </span>
                      <span className={v.travelColor}>→ {v.travel}</span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
